var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 609.1 279.2",
    style: {
      enableBackground: "new 0 0 609.1 279.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.6,206.2c0,0-93.1,40-105.8-55.9h110.9c0,0,16.5-82.5-77.8-83.4C25.2,66,15.8,140,22.3,176.1 c5.3,29.7,29.6,76.5,90.2,76.5c60.6,0,77-41.8,77-41.8L185.6,206.2z M112.3,75.5c20.8,1,27.4,28.8,27.4,44.4 c0,15.6-10.5,14.6-15,14.6H77.6C75,108.3,81.8,74.1,112.3,75.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,17.8v206.1c0,5.6,5.3,14.6,16.9,16.6v5.8h-35.7c-22.7,0-41-17.9-40.9-40L222.9,60 c0,0,0.5-11.6-13.4-14.9v-7L282.1,17.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.7,17.8v206.1c0,5.6,5.3,14.6,16.9,16.6v5.8h-35.7c-22.7,0-41-17.9-40.9-40L323.5,60 c0,0,0.5-11.6-13.4-14.9v-7L382.7,17.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M575.5,206.2c0,0-93.1,40-105.8-55.9h110.9c0,0,16.5-82.5-77.8-83.4c-87.7-0.8-97.1,73.1-90.7,109.2 c5.3,29.7,29.6,76.5,90.2,76.5c60.6,0,77-41.8,77-41.8L575.5,206.2z M502.2,75.5c20.8,1,27.4,28.8,27.4,44.4 c0,15.6-10.5,14.6-15,14.6h-47.1C464.9,108.3,471.7,74.1,502.2,75.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElleLogo);
export default __webpack_public_path__ + "static/media/elle_logo.11c50f72998a87518b034adfdc603d26.svg";
export { ForwardRef as ReactComponent };